import { useAuth } from '../AuthContext';
import { Navigate } from 'react-router-dom';

// Tela de arbitragem: árbitros e Admin/Diretor.
export function ArbitroMiddleware({ children }) {
  const { isAuthenticated, userLogado } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/arbitro/login" />;
  }
  if (!['Arbitro', 'Admin', 'Diretor'].includes(userLogado?.perfil)) {
    return <Navigate to="/painel" />;
  }
  return children;
}
